import React, { forwardRef } from "react";
import { get } from "lodash";
import { oneOf, shape } from "prop-types";

import {
  formikInjectedFieldPropTypes,
  formikInjectedFormPropTypes
} from "../formikPropTypes";
import InputWithLabel from "../InputWithLabel";

const LabelledInput = forwardRef(({ field, form, type, ...props }, ref) => {
  const inputProps = { ...props, ...field };
  const fieldError = get(form.errors, field.name);

  if (inputProps.handleBlur) {
    inputProps.onBlur = e => {
      field.onBlur(e);
      inputProps.handleBlur(e);
    };
  }

  if (inputProps.handleChange) {
    inputProps.onChange = e => {
      field.onChange(e);
      inputProps.handleChange(e);
    };
  }

  return (
    <InputWithLabel
      ref={ref}
      {...inputProps}
      disabled={inputProps.disabled ?? inputProps.isDisabled}
      errorMessage={fieldError}
      type={inputProps.isHidden ? "hidden" : type}
    />
  );
});

LabelledInput.displayName = "Input_LabelledInput";

LabelledInput.propTypes = {
  field: shape(formikInjectedFieldPropTypes).isRequired,
  form: shape(formikInjectedFormPropTypes).isRequired,
  type: oneOf(["text", "textarea", "toggle", "select"]).isRequired
};

export default LabelledInput;
